import i18n, { use as i18nUse, t } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { translations } from 'locale/locale';
import { ILanguage } from 'graphql/types';

i18nUse(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: translations,
        detection: { lookupLocalStorage: 'language' },
        fallbackLng: ILanguage.En,
        debug: import.meta.env.MODE === 'development',
    });

const translate = t.bind(i18n);

export { i18n, translate };
